export const headers = ['ID', 'Balance R$', 'Date added', 'Position', 'Delete', 'History']
